import { render, staticRenderFns } from "./UpData.vue?vue&type=template&id=17c06fd8&scoped=true&"
import script from "./UpData.vue?vue&type=script&lang=js&"
export * from "./UpData.vue?vue&type=script&lang=js&"
import style0 from "./UpData.vue?vue&type=style&index=0&id=17c06fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c06fd8",
  null
  
)

export default component.exports